import styled from "styled-components";

export const StyledPortalFooterCard = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
  padding: 16px;

  &.for-modal {
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  &.for-confirm-modal {
    padding-top: 0;
  }
`;
